var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 48,
    viewBox: "0 0 30 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 4.57146H20.5713V1.14289C20.5713 0.512036 20.0594 0 19.4285 0H10.2857C9.65486 0 9.14282 0.512036 9.14282 1.14289V4.57146H5.71425C2.56222 4.57146 0 7.13604 0 10.2857V42.2858C0 45.4354 2.56232 48 5.71425 48H24C27.152 48 29.7143 45.4354 29.7143 42.2858V10.2857C29.7143 7.13604 27.1519 4.57146 23.9999 4.57146ZM22.7656 24.4503L15.9085 40.4503C15.7257 40.8754 15.3074 41.1429 14.8571 41.1429C14.7816 41.1429 14.7062 41.136 14.6262 41.12C14.0959 41.0103 13.7142 40.5418 13.7142 40.0001V29.7144H7.99993C7.61593 29.7144 7.25711 29.5224 7.04679 29.2001C6.83421 28.8778 6.79993 28.4732 6.94854 28.1213L13.8057 12.1213C14.0205 11.623 14.5371 11.3418 15.088 11.4515C15.6182 11.5612 16 12.0298 16 12.5715V22.8572H21.7142C22.0982 22.8572 22.457 23.0492 22.6674 23.3715C22.8799 23.6914 22.9142 24.096 22.7656 24.4503Z",
    fill: "#5495C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.deecbbe9.svg";
export { ForwardRef as ReactComponent };